//atribuir evento de change ao input[type="date"] na página de busca
const dateInputs = document.querySelectorAll('input[type="date"]');
dateInputs.forEach(input => {
  input.addEventListener('change', function() {
    input.value === ''
      ? input.classList.add("date-input--empty")
      : input.classList.remove("date-input--empty");
  });
});